import session from '../util/session'
import { trackEvent } from '../util/analytics'
import { registrationEntryPath } from 'shared/javascripts/util/registration'

up.compiler('[data-bookmark-link]', (element) => {
  const videoId = parseInt(element.getAttribute('data-bookmark-link')!)
  const selector = `[data-bookmark-link="${videoId}"] .bookmark-icon`
  const bookmarkIcons = document.querySelectorAll(selector)
  const bookmarkLabels = document.querySelectorAll(
    `[data-bookmark-link="${videoId}"] .bookmark-button--label`,
  )
  const nextBookmarkIcon = element.querySelector('.bookmark-icon')!

  const bookmarkedVideoIds = session.bookmarkedVideoIds
  if (bookmarkedVideoIds.includes(videoId)) {
    bookmarkIcons.forEach((icon) => icon.classList.add('-marked'))
    bookmarkLabels.forEach((label) => (label.textContent = 'Gemerkt'))
  }

  function isMarked(elements: NodeListOf<Element>) {
    return Array.from(elements).some((e) => e.matches('.-marked'))
  }

  element.addEventListener('click', (event) => {
    if (session.signedIn) {
      if (isMarked(bookmarkIcons)) {
        session.removeBookmarkedVideo(videoId)
        bookmarkIcons.forEach((icon) => icon.classList.remove('-marked'))
        bookmarkLabels.forEach((label) => (label.textContent = 'Merken'))
        trackEvent('bookmark.removed', { video: { id: videoId } })
      } else {
        session.addBookmarkedVideo(videoId)
        bookmarkIcons.forEach((icon) => icon.classList.add('-marked'))
        bookmarkLabels.forEach((label) => (label.textContent = 'Gemerkt'))
        trackEvent('bookmark.added', { video: { id: videoId } })
      }
      nextBookmarkIcon.classList.add('-clicked')
    } else {
      const returnTo = window.location.pathname + window.location.search
      up.visit(registrationEntryPath(returnTo))
    }

    event.preventDefault()
    event.stopPropagation()
  })

  element.addEventListener('mouseleave', (event) => {
    if (nextBookmarkIcon && nextBookmarkIcon.matches('.-clicked')) {
      nextBookmarkIcon.classList.remove('-clicked')
    }
  })
})
